import { render, staticRenderFns } from "./KaojiApplyLayout.vue?vue&type=template&id=c69c2fbe&scoped=true&"
import script from "./KaojiApplyLayout.vue?vue&type=script&lang=js&"
export * from "./KaojiApplyLayout.vue?vue&type=script&lang=js&"
import style0 from "./KaojiApplyLayout.vue?vue&type=style&index=0&id=c69c2fbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69c2fbe",
  null
  
)

export default component.exports